import React, { Component } from "react";
import { Link } from "react-router-dom";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBeyondPulse: false
    };
  }

  componentDidMount() {
    // Add scroll event listener to detect when user scrolls
    if (!this.props.isBeyondPage) {
      window.addEventListener('scroll', this.handleScroll);
      // Show animation after 3 seconds initially
      setTimeout(() => {
        this.setState({ showBeyondPulse: true });
      }, 3000);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    // Show pulse animation when user scrolls past 50% of the page
    const scrollPercentage = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
    
    if (scrollPercentage > 50 && !this.state.showBeyondPulse) {
      this.setState({ showBeyondPulse: true });
    }
  }

  render() {
    if (this.props.sharedBasicInfo) {
      var networks = this.props.sharedBasicInfo.social.map(function (network) {
        return (
          <span key={network.name} className="m-4">
            <a href={network.url} target="_blank" rel="noopener noreferrer">
              <i className={network.class}></i>
            </a>
          </span>
        );
      });
    }

    const isBeyondPage = this.props.isBeyondPage;

    return (
      <footer>
        <div className="col-md-12">
          <div className="social-links">{networks}</div>

          <div className="footer-nav" style={{ marginTop: '20px', marginBottom: '10px' }}>
            {isBeyondPage ? (
              <Link to="/" className="footer-link">
                <span className="iconify" data-icon="mdi:arrow-left" data-inline="false" style={{ marginRight: '8px' }}></span>
                Back to Portfolio
              </Link>
            ) : (
              <Link 
                to="/beyond" 
                className={`footer-link ${this.state.showBeyondPulse ? 'beyond-button-pulse' : ''}`}
              >
                <span className="iconify" data-icon="mdi:trophy" data-inline="false" style={{ marginRight: '8px' }}></span>
                Beyond Tech - Leadership & Community
              </Link>
            )}
          </div>

          <div className="copyright py-4 text-center">
            <div className="container">
              <small>
                Copyright &copy;{" "}
                {this.props.sharedBasicInfo
                  ? this.props.sharedBasicInfo.name
                  : "???"}
              </small>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
